import { render } from "./classement_create.vue?vue&type=template&id=33a00308"
import script from "./classement_create.vue?vue&type=script&lang=js"
export * from "./classement_create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__